<template>
  <div class="goods">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>商品訊息</p>
    </div>
    <!-- 商品名稱 -->
    <el-form>
      <el-form-item label="名稱:">
        <input
          maxlength="60"
          placeholder="請輸入商品名稱（60個字符以內）"
          class="el-input__inner"
          type="text"
          v-model="goods.name"
        />
      </el-form-item>

      <el-form-item
        label="編號:"
        v-if="
          type === 'edit' &&
            (goods.status === '售賣中' || goods.status === '已下架')
        "
      >
        <el-input disabled v-model="goods.id" type="text" />
      </el-form-item>

      <el-form-item label="編號:" v-else>
        <el-input
          placeholder="請輸入商品編號，僅支持數字"
          v-model="goods.id"
          type="text"
          maxlength="12"
          @change="goods.id = goods.id.replace(/\D/g, '')"
        />
      </el-form-item>

      <!-- 商品主圖 -->
      <el-form-item
        label="主圖:"
        class="picupload"
        v-show="
          type === 'add' ||
            (type === 'edit' &&
              (goods.status === '即將售賣' || goods.status === '已下架'))
        "
      >
        <el-upload
          action=""
          :http-request="uploadRequest.bind(this, 0)"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :data="uploadData"
          :on-remove="handleRemove"
          :on-error="$errorImage"
          :file-list="mainPicUrl"
          :on-exceed="$handleExceed.bind(this, 5)"
          :before-upload="beforePicUpload"
          :limit="5"
          accept=".jpg,.jpeg,.png"
          :multiple="false"
          name="mainPic"
          list-type="picture-card"
        >
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">
            需上傳完整500*500的正方形圖標，支持jpg/png格式(2MB以內)
          </div>
        </el-upload>
      </el-form-item>
      <!-- 商品類型 -->
      <el-form-item label="類型:" v-if="type === 'edit'">
        <p class="blackColor" v-if="goods.type == 0">所有用戶</p>
        <p class="blackColor" v-if="goods.type == 2">僅測試人員</p>
      </el-form-item>

      <el-form-item label="類型:" v-else>
        <el-radio-group v-model="goods.type">
          <el-radio :label="0">所有用戶</el-radio>
          <el-radio :label="2">僅測試人員</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 定時上架 -->
      <el-form-item
        label="定時上架:"
        v-show="
          type === 'add' || (type === 'edit' && goods.status === '即將售賣')
        "
      >
        <el-switch active-color="#6C3DEA" v-model="goods.timing"> </el-switch>
        <div class="timingTips" v-show="!goods.timing">
          <p>若關閉定時上架，您發佈的商品將會即時上架，請確認後發佈。</p>
        </div>
      </el-form-item>

      <el-form-item
        v-if="
          (goods.timing && type === 'add') ||
            (type === 'edit' && goods.status === '即將售賣' && goods.timing)
        "
        label="上架時間 ："
      >
        <el-date-picker
          v-model="goods.shelfTime"
          type="datetime"
          placeholder="选择时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        v-if="
          type === 'edit' &&
            (goods.status === '售賣中' || goods.status === '已下架')
        "
        label="上架時間 ："
      >
        <el-date-picker
          disabled
          v-model="goods.shelfTime"
          type="datetime"
          placeholder="选择时间"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>

    <!-- 商品詳情 -->
    <div class="detailsTitle" v-if="goodsList.length != 0">
      <div class="detailsWrap"></div>
      <p>商品详情</p>
    </div>
    <div v-for="(item, index) in goodsList" :key="index">
      <div
        class="detailsTitle"
        style="margin-left:0.2rem;display: flex;justify-content: space-between;"
      >
        <p>商品{{ index + 1 }}:</p>
        <img
          style="display: block;width: 0.22rem;height: 0.22rem;"
          src="../assets/images/market/detailsdDel.png"
          v-show="index !== 0 && type === 'add'"
          @click="delGoodsItem(index, goodsList)"
        />
      </div>
      <el-form>
        <el-form-item label="商品名稱:">
          <input
            maxlength="60"
            placeholder="請輸入商品名稱（60個字符以內）"
            class="el-input__inner"
            type="text"
            v-model="item.name"
          />
        </el-form-item>

        <el-form-item
          label="主圖:"
          class="itmePicupload"
          v-show="
            type === 'add' ||
              (type === 'edit' &&
                (goods.status === '即將售賣' || goods.status === '已下架'))
          "
        >
          <el-upload
            action=""
            :http-request="uploadRequest.bind(this, index)"
            :headers="{ Authorization: auth }"
            :with-credentials="true"
            :data="uploadData"
            :on-remove="itemHandleRemove.bind(this, index)"
            :on-error="$errorImage"
            :file-list="item.mainImg"
            :on-exceed="$handleExceed.bind(this, 1)"
            :before-upload="beforePicUpload"
            :limit="1"
            accept=".jpg,.jpeg,.png"
            :multiple="false"
            name="goodsPic"
            list-type="picture-card"
          >
            <el-button size="small" type="primary">選擇圖片</el-button>
            <div slot="tip" class="el-upload__tip">
              需上傳完整500*500的正方形圖標，支持jpg/png格式(2MB以內)
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="商品編號:"
          v-if="
            type === 'edit' &&
              (goods.status === '售賣中' || goods.status === '已下架')
          "
        >
          <el-input disabled v-model="item.id" type="text" />
        </el-form-item>

        <el-form-item label="商品編號:" v-else>
          <el-input
            placeholder="請輸入商品編號，僅支持數字"
            v-model="item.id"
            type="text"
            maxlength="12"
            @change="item.id = item.id.replace(/\D/g, '')"
          />
        </el-form-item>

        <el-form-item label="商品類型:" v-if="type === 'add'">
          <el-select v-model="item.goodsType" placeholder="請選擇商品類型">
            <el-option label="入會禮" value="4"></el-option>
            <el-option label="會籍" value="1"></el-option>
            <el-option label="會服" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品類型:" v-else>
          <el-select
            v-model="item.goodsType"
            disabled
            placeholder="請選擇商品類型"
          >
            <el-option label="入會禮" value="4"></el-option>
            <el-option label="會籍" value="1"></el-option>
            <el-option label="會服" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="type === 'edit' && goods.status === '售賣中'"
          label="限購數量:"
        >
          <el-input disabled v-model="item.limited" type="text" />
        </el-form-item>

        <el-form-item v-else label="限購數量:">
          <el-input-number
            v-model="item.limited"
            :controls="false"
            :min="1"
            :max="99"
          >
          </el-input-number>
        </el-form-item>

        <el-form-item v-show="type == 'add'" label="必選商品">
          <el-switch active-color="#6C3DEA" v-model="item.require"> </el-switch>
        </el-form-item>
      </el-form>

      <div class="detailsTitle" v-show="type === 'add'">
        <div class="detailsWrap"></div>
        <p>商品庫存</p>
      </div>

      <el-form v-show="type === 'add'">
        <el-form-item class="goodsAdd" label="SKU:">
          <div
            class="goodsWrap"
            v-for="(skuItem, skuIndex) in item.skuList"
            :key="skuIndex"
          >
            <div class="goodsItem">
              <input
                v-model="skuItem.value"
                class="el-input__inner"
                type="text"
                maxlength="20"
              />
            </div>
            <span
              v-show="skuIndex !== 0 && type === 'add'"
              class="delBtn"
              @click="delGoodsItem(skuIndex, item.skuList)"
              >删除</span
            >
          </div>
          <div
            v-show="item.skuList.length < 6"
            class="addDetail"
            @click="addSku(item.skuList)"
          >
            添加
          </div>
          <table class="skuTable">
            <thead>
              <tr>
                <th>商品尺寸</th>
                <th>價格(TWD)</th>
                <th>價格(CNY)</th>
                <th>總庫存</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(skuItem, skuIndex) in item.skuList" :key="skuIndex">
                <td>
                  {{ skuItem.value }}
                </td>
                <td>
                  <!-- <input type="text" name="" id="" v-model="skuItem.price"  @change="skuItem.price=skuItem.price.replace(/^(0+)|[^\d]+/g,'')"> -->
                  <input
                    type="text"
                    name=""
                    id=""
                    v-model="skuItem.realPrice"
                    @change="
                      skuItem.price = skuItem.realPrice.replace(/\D/g, '')
                    "
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name=""
                    id=""
                    v-model="skuItem.priceRmb"
                    @change="
                      skuItem.priceRmb = skuItem.priceRmb.replace(/\D/g, '')
                    "
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name=""
                    id=""
                    v-model="skuItem.realTotal"
                    @change="
                      skuItem.realTotal = skuItem.realTotal.replace(
                        /^(0+)|[^\d]+/g,
                        ''
                      )
                    "
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </el-form-item>
      </el-form>

      <div class="goodLine"></div>
    </div>

    <!-- 增加商品 -->
    <div style="display: flex;justify-content: flex-end;">
      <div
        v-if="type === 'add'"
        class="addDetail"
        style="margin-bottom:40px;"
        @click="addGoods()"
      >
        增加商品
      </div>
    </div>

    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>詳細訊息</p>
    </div>

    <el-form>
      <el-form-item class="goodsAdd" label="注意事項:">
        <div
          class="goodsWrap"
          v-for="(item, index) in goodsService"
          :key="index"
        >
          <div class="goodsItem">
            <input v-model="item.fileUrl" class="el-input__inner" type="text" />
          </div>
          <span
            v-show="!(index === 0)"
            class="delBtn"
            @click="delGoodsItem(index, goodsService)"
            >删除</span
          >
        </div>

        <div
          v-show="goodsService.length < 3"
          class="addDetail"
          @click="addGoodesService()"
        >
          添加
        </div>
      </el-form-item>

      <div class="editor-wrap">
        <p class="editor-title normal_font">購買須知:</p>
        <Editor
          class="editor"
          style="color:#fff;"
          @listenContent="getBuyContent"
          :colorFlag="true"
          :content="buyContent"
          :newsFlag="true"
          :id="editorBuyId"
        ></Editor>
      </div>

      <div class="editor-wrap">
        <p class="editor-title normal_font">商品介紹:</p>
        <Editor
          class="editor"
          style="color:#fff;"
          @listenContent="getContent"
          :colorFlag="true"
          :content="content"
          :newsFlag="true"
          :id="editorId"
        ></Editor>
      </div>
    </el-form>

    <div class="bottomBtn">
      <div
        class="btn"
        v-if="type === 'edit' && goods.status === '已下架'"
        @click="submitContent()"
      >
        保存
      </div>
      <div class="btn" v-else @click="submitContent()">發佈</div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import Editor from "@/components/editor";
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
export default {
  props: ["type", "id"],
  data() {
    return {
      itemImgUpUrl: this.$GLOBAL.imagespostUrl,
      auth: this.$cookie.get("auth"),
      editorId: "contentId",
      editorBuyId: "buyContentId",
      mainPicUrl: [], // 商品主图
      goods: {
        name: "", //商品名稱
        id: "",
        type: 0,
        timing: false,
        shelfTime: "",
        status: ""
      },
      goodsList: [
        {
          require: false, //是否為必選商品
          name: "", // 商品名稱
          id: "", // 商品編號
          limited: "", //限購數量
          status: "", // 商品的状态
          skuList: [
            {
              turn: 1,
              value: "",
              realPrice: "",
              priceRmb: "",
              realTotal: ""
            }
          ],
          mainImg: [],
          goodsType: ""
        }
      ],
      content: "", // 商品介紹
      // 注意事項
      goodsService: [
        {
          type: 4,
          fileUrl: "",
          seq: 1,
          isDel: 1,
          remark: ""
        }
      ],
      // 購買須知
      buyContent: "",
      // 上传图片的附加参数
      uploadData: {
        flag: "xw"
      },
      submitFlag: true, // 禁止用户连续点击，发出多次请求接口
      dialogVisible: false
    };
  },
  created() {
    let _this = this;
    if (_this.type === "edit") {
      _this.getGoodsDetails();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    //获取编辑商品的商品详情
    getGoodsDetails() {
      let _this = this;
      _this
        .$post(
          `/request/mall/queryGoodsDetails?goodsId=${_this.id}`,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            let status = "";
            if (res.data[0].status == 0) {
              status = "已下架";
            } else if (res.data[0].status == 1) {
              status = "售賣中";
            } else if (res.data[0].status == 2) {
              status = "即將售賣";
            } else if (res.data[0].status == 3) {
              status = "已刪除";
            }
            if (res.data.length == 1) {
              _this.goods = {
                goodsId: _this.id,
                name: res.data[0].goodsName, //商品名称
                type: res.data[0].goodsTerm + "", // 数字变为字符串,測試或所有人員
                limited: res.data[0].buyMaxNum, //限购数量
                status: status,
                id: res.data[0].goodsNo, //商品编号
                timing: status === "即將售賣" ? true : false, //是否定时上架
                shelfTime: _this.$getTime(res.data[0].startTime) //上架时间
              };
              _this.goodsList = [];
            } else if (res.data.length > 1) {
              let idArr = _this.id.split(",");
              _this.goods = {
                goodsId: idArr[0],
                name: res.data[0].goodsName,
                id: res.data[0].goodsNo,
                type: res.data[0].goodsTerm + "", // 数字变为字符串
                timing: status === "即將售賣" ? true : false,
                shelfTime: _this.$getTime(res.data[0].startTime),
                status: status
                // limited:res.data[0].buyMaxNum,
              };

              let dataArr = res.data.slice(1);
              let idSurplus = idArr.slice(1);

              _this.goodsList = [];
              for (let i in dataArr) {
                _this.goodsList.push({
                  goodsId: idSurplus[i],
                  require: dataArr[i].isDefault == 1 ? true : false,
                  status: dataArr[i].goodsTerm + "", // 数字变为字符串
                  name: dataArr[i].goodsName,
                  id: dataArr[i].goodsNo,
                  limited: dataArr[i].buyMaxNum,
                  skuList: dataArr[i].skuDtoList,
                  mainImg: [{ name: "img.jpg", url: dataArr[i].imgUrl }],
                  goodsType: dataArr[i].type
                });
              }
            }

            // 图片列表
            for (let i in res.data[0].accessoryDto.imgUrl) {
              _this.mainPicUrl.push({
                name: "img.jpg",
                url: res.data[0].accessoryDto.imgUrl[i].imgUrlStr
              });
            }

            if (_this.mainPicUrl.length === 5) {
              document.getElementsByClassName("el-upload")[0].style.display =
                "none";
            }
            // 注意事項
            _this.goodsService = [];

            for (let j in res.data[0].accessoryDto.goodsServicesList) {
              _this.goodsService.push({
                type: 4,
                fileUrl:
                  res.data[0].accessoryDto.goodsServicesList[j]
                    .goodsServicesStr,
                seq: Number(j) + 1,
                isDel: 1,
                remark: ""
              });
            }

            // 购买须知
            this.buyContent = "";
            for (let k in res.data[0].accessoryDto.purchaseNotesDtoList) {
              this.buyContent =
                this.buyContent +
                res.data[0].accessoryDto.purchaseNotesDtoList[k].mainDody;
            }
            // 商品介紹
            _this.content = res.data[0].accessoryDto.graphicDetails;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },

    // 图片上传之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$Mint.Toast("上傳圖片只能是jpg或者png格式!");
        return false;
      }
      if (!isLt2M) {
        this.$Mint.Toast("上傳圖片大小不能超過2MB!");
        return false;
      }

      const isSize = new Promise(function(resolve, reject) {
        let width = 500;
        let height = 500;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width === width && img.height === height;
          valid ? resolve() : reject(new Error());
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          _this.dialogVisible = true;
          _this.$propMessage("上传图片大小需为500*500", "error", function() {
            _this.dialogVisible = false;
          });

          return Promise.reject(new Error());
        }
      );
      return isJPG && isLt2M && isSize;
    },

    // 移除图片的回调函数
    handleRemove(file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.mainPicUrl);
      if (_this.mainPicUrl.length < 5) {
        document.getElementsByClassName("el-upload")[0].style.display =
          "inline-block";
      }
    },
    itemHandleRemove(index, file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.goodsList[index].mainImg);
      if (_this.goodsList[index].mainImg.length < 5) {
        document.getElementsByClassName("el-upload")[index + 1].style.display =
          "inline-block";
      }
    },
    uploadRequest(index, option) {
      console.log(index, option);
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        const fileWay = "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" }
            })
            .then(
              val => {
                console.log(val);
                if (val.res.statusCode === 200) {
                  if (option.filename === "mainPic") {
                    // 列表主图横图
                    self.mainPicUrl.push({
                      name: "img.jpg",
                      url: self.$GLOBAL.picFileUrl + val.name
                    }); // 展示图片
                    //cdn预热
                    self.$cdnFun(self.mainPicUrl[0].url).then(res => {
                      console.log(res);
                    });
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                  } else {
                    self.goodsList[index].mainImg.push({
                      name: "img.jpg",
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic
                    });
                    //cdn预热
                    self
                      .$cdnFun(self.goodsList[index].mainImg[0].url)
                      .then(res => {
                        console.log(res);
                      });
                    if (self.goodsList[index].mainImg.length === 1) {
                      document.getElementsByClassName("el-upload")[
                        index + 1
                      ].style.display = "none";
                    }
                  }
                  return val;
                } else {
                  option.onError("上传失败1");
                }
              },
              err => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    // 增加sku
    addSku(skuList) {
      let _this = this;
      let length = skuList.length;
      skuList.push({
        turn: Number(length + 1),
        value: "",
        realPrice: "",
        priceRmb: "",
        realTotal: ""
      });
    },
    //增加商品
    addGoods() {
      let _this = this;
      _this.goodsList.push({
        require: false, //必選商品
        name: "", // 商品名稱
        id: "", // 商品編號
        limited: "", //限購數量
        status: "", // 商品的状态
        skuList: [
          {
            turn: 1,
            value: "",
            realPrice: "",
            priceRmb: "",
            realTotal: ""
          }
        ],
        mainImg: [],
        goodsType: ""
      });
    },
    // 增加注意事項
    addGoodesService() {
      let _this = this;
      let length = _this.goodsService.length;
      _this.goodsService.push({
        type: 4,
        fileUrl: "",
        seq: Number(length + 1),
        isDel: 1,
        remark: ""
      });
    },
    // 删除列表
    delGoodsItem(index, itemList) {
      itemList.splice(index, 1);
    },

    // 实时获取商品介紹
    getContent(data) {
      let _this = this;
      _this.content = data;
    },
    // 實時获取購買須知
    getBuyContent(data) {
      let _this = this;
      _this.buyContent = data;
    },
    submitFn() {
      let _this = this;
      if (_this.submitFlag === true) {
        _this.submitFlag = false;

        //確認發佈
        let imgList = [];
        for (let i in _this.mainPicUrl) {
          imgList.push({
            type: 1,
            fileUrl: _this.mainPicUrl[i].url,
            seq: Number(Number(i) + 1),
            isDel: 1,
            remark: ""
          });
        }
        // 商品介紹
        let contentParam = {
          type: 2,
          fileUrl: _this.content,
          seq: 1,
          isDel: 1,
          remark: ""
        };
        // 購買須知
        let buyContentParam = {
          type: 5,
          fileUrl: _this.buyContent,
          seq: 1,
          isDel: 1,
          remark: ""
        };
        let status = "";
        if (_this.goods.status === "已下架") {
          status = 0;
        } else if (_this.goods.status === "售賣中") {
          status = 1;
        } else {
          if (_this.goods.timing) {
            //定時發佈
            status = 2; //即將售賣
          } else {
            status = 1; //上架
          }
        }

        //增加商品提交
        if (_this.type === "add") {
          // 商品訊息參數
          let firstParam = [
            {
              goodsTitle: _this.goods.name,
              goodType: 6, // 禮包
              goodsPrice: _this.goodsList[0].skuList[0].realPrice,
              maxBuyNum: 1,
              status: status,
              isCron: _this.goods.timing ? 1 : 0, //定時上架flag
              isDefault: 0,
              img: _this.mainPicUrl[0].url,
              goodsNo: _this.goods.id,
              startTime: _this.goods.timing
                ? _this.$formatDate(_this.goods.shelfTime)
                : _this.$formatDate(new Date()),
              goodsTerm: Number(_this.goods.type), // 全部0或者測試1
              weight: "20",
              length: "20",
              width: "20",
              height: "20",
              goodsAttachList: _this.goodsService
                .concat(buyContentParam)
                .concat(imgList)
                .concat(contentParam),
              shipFee: 0 //免運費
            }
          ];

          let goodsParam = [];
          for (let i in _this.goodsList) {
            goodsParam.push({
              goodsTitle: _this.goodsList[i].name,
              goodType: Number(_this.goodsList[i].goodsType), // 禮包
              goodsPrice: _this.goodsList[i].skuList[0].price,
              maxBuyNum: _this.goodsList[i].limited,
              status: status,
              isCron: _this.goods.timing ? 1 : 0, //定時上架flag
              img: _this.goodsList[i].mainImg[0].url,
              goodsNo: _this.goodsList[i].id,
              startTime: _this.goods.timing
                ? _this.$formatDate(_this.goods.shelfTime)
                : _this.$formatDate(new Date()),
              goodsTerm: Number(_this.goods.type), // 全部0或者測試1
              isDefault: _this.goodsList[i].require ? 1 : 0,
              weight: "20",
              length: "20",
              width: "20",
              height: "20",
              skuRequestList: _this.goodsList[i].skuList, // sku
              goodsAttachList: _this.goodsService
                .concat(buyContentParam)
                .concat(contentParam)
                .concat({
                  type: 1,
                  fileUrl: _this.goodsList[i].mainImg[0].url,
                  seq: Number(Number(i) + 1),
                  isDel: 1,
                  remark: ""
                }),
              shipFee: Number(_this.goodsList[i].goodsType) == 1 ? 0 : 1 //免運費
            });
          }
          let param = firstParam.concat(goodsParam);
          _this
            .$post(
              "/request/mall/saveMulGoods",
              param,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("新增商品成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/memberGoodsList");
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        } else {
          // 编辑商品提交
          let startTime = "";

          if (_this.goods.status === "即將售賣") {
            if (typeof _this.goods.shelfTime === "string") {
              // 回显的上架时间没有修改
              startTime = _this.goods.shelfTime;
            } else {
              // 回显的上架时间修改，即为标准时间格式，需要变更格式
              startTime = _this.$formatDate(_this.goods.shelfTime);
            }
          } else {
            // 其他状态下，上架时间无法修改，即为字符串格式，不需变更格式
            startTime = _this.goods.shelfTime;
          }

          let editFirstParam = [
            {
              goodsId: _this.goods.goodsId,
              goodsName: _this.goods.name,
              buyMaxNum: 1,
              status: status,
              isCron: _this.goods.timing ? 1 : 0, //定時上架flag
              imgUrl: _this.mainPicUrl[0].url,
              goodsNo: _this.goods.id,
              startTime: startTime,
              goodsAttachList: _this.goodsService
                .concat(buyContentParam)
                .concat(imgList)
                .concat(contentParam)
            }
          ];

          let editParam = [];
          let param;
          if (_this.goodsList.length != 0) {
            for (let i in _this.goodsList) {
              editParam.push({
                goodsId: _this.goodsList[i].goodsId,
                goodsName: _this.goodsList[i].name,
                buyMaxNum: _this.goodsList[i].limited,
                status: status,
                isCron: _this.goods.timing ? 1 : 0, //定時上架flag
                imgUrl: _this.goodsList[i].mainImg[0].url,
                goodsNo: _this.goodsList[i].id,
                startTime: startTime,
                goodsAttachList: _this.goodsService
                  .concat(buyContentParam)
                  .concat(contentParam)
                  .concat({
                    type: 1,
                    fileUrl: _this.goodsList[i].mainImg[0].url,
                    seq: Number(Number(i) + 1),
                    isDel: 1,
                    remark: ""
                  })
              });
            }

            param = editFirstParam.concat(editParam);
          } else {
            param = editParam;
          }

          _this
            .$post(
              "/request/mall/updateGoodsDetails",
              param,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("編輯商品成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/memberGoodsList");
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        }
      }
      setTimeout(() => {
        _this.submitFlag = true;
      }, 5000);
    },
    // 提交商品（新增或编辑）
    submitContent() {
      let _this = this;

      if (_this.goods.name === "" || _this.$getCaption(_this.goods.name)) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "商品名稱不能為空或者含有非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );
        return false;
      }

      if (_this.goods.id === "") {
        _this.dialogVisible = true;
        _this.$propMessage("商品編號不能為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (_this.goods.type === "") {
        _this.$warnMessage("商品類型不能為空");

        return false;
      }

      if (_this.mainPicUrl.length === 0) {
        _this.dialogVisible = true;
        _this.$propMessage("商品主圖不能為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      for (let i in _this.goodsList) {
        if (
          _this.goodsList[i].name === "" ||
          _this.$getCaption(_this.goodsList[i].name)
        ) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "商品名稱不能為空或含有非法字符",
            "error",
            function() {
              _this.dialogVisible = false;
            }
          );
          return false;
        }

        if (_this.goodsList[i].mainImg.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("商品主圖不能為空", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }

        if (_this.goodsList[i].id === "") {
          _this.dialogVisible = true;
          _this.$propMessage("商品編號不能為空", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }

        if (_this.goodsList[i].goodsType === "") {
          _this.dialogVisible = true;
          _this.$propMessage("商品類型不能為空", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }

        if (_this.goodsList[i].limited === "") {
          _this.dialogVisible = true;
          _this.$propMessage("限購數量不能為空", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }

      if (
        _this.type === "add" ||
        (_this.type === "edit" && _this.goods.status == "即將售賣")
      ) {
        if (_this.goods.timing) {
          // 定時
          let timeFormat = _this.$compareTime(
            _this.goods.shelfTime,
            new Date()
          );
          if (_this.goods.shelfTime === null || timeFormat === false) {
            _this.dialogVisible = true;
            _this.$propMessage(
              "定時發佈時間不能為空，且只能設置未來時間",
              "error",
              function() {
                _this.dialogVisible = false;
              }
            );
            return false;
          }
        }
      }

      // 编辑商品不能编辑sku，故只有新增商品判断sku是否为空
      if (_this.type === "add") {
        let goodsId = [];
        let requireList = [];
        let bool = false;
        goodsId.push(_this.goods.id);

        for (let j in _this.goodsList) {
          requireList.push(_this.goodsList[j].require);
          goodsId.push(_this.goodsList[j].id);
        }

        let idString = goodsId.join(",") + ",";
        for (let g = 0; g < goodsId.length; g++) {
          if (
            idString.replace(goodsId[g] + ",", "").indexOf(goodsId[g] + ",") >
            -1
          ) {
            _this.dialogVisible = true;
            _this.$propMessage("商品編號不能重複", "error", function() {
              _this.dialogVisible = false;
            });
            return false;
          }
        }
        for (let k = 0, len = requireList.length; k < len; k++) {
          if (requireList[k] != false) {
            bool = true;
          }
        }
        if (!bool) {
          _this.dialogVisible = true;
          _this.$propMessage("至少需要一個必選商品！", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }

        for (let i in _this.goodsList) {
          if (
            _this.goodsList[i].skuList.length === 1 &&
            _this.goodsList[i].skuList[0].value === ""
          ) {
            _this.dialogVisible = true;
            _this.$propMessage("商品SKU不能為空", "error", function() {
              _this.dialogVisible = false;
            });

            return false;
          }
          for (let k in _this.goodsList[i].skuList) {
            if (
              _this.goodsList[i].skuList[k].realPrice === "" ||
              _this.goodsList[i].skuList[k].priceRmb === "" ||
              _this.goodsList[i].skuList[k].value === "" ||
              _this.goodsList[i].skuList[k].realTotal === "" ||
              _this.$getCaption(_this.goodsList[i].skuList[k].value)
            ) {
              _this.dialogVisible = true;
              _this.$propMessage(
                "商品SKU不能有選項為空或者含有非法字符",
                "error",
                function() {
                  _this.dialogVisible = false;
                }
              );
              return false;
            }
          }
        }
      }

      if (
        _this.goodsService.length === 1 &&
        _this.goodsService[0].fileUrl === ""
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("注意事項不能為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      for (let j in _this.goodsService) {
        if (
          _this.goodsService[j].fileUrl === "" ||
          _this.$getCaption(_this.goodsService[j].fileUrl)
        ) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "注意事項不能有選項為空或者含有非法字符",
            "error",
            function() {
              _this.dialogVisible = false;
            }
          );
          return false;
        }
      }

      if (_this.buyContent === "") {
        _this.dialogVisible = true;
        _this.$propMessage("購買須知不能為空", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (_this.content === "" || _this.content === null) {
        _this.dialogVisible = true;
        _this.$propMessage("圖文詳情不能為空", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (_this.type === "edit" && _this.goods.status === "已下架") {
        _this.submitFn();
      } else {
        _this
          .$confirm(
            "是否發佈該商品，發佈後將在商品列表中展示商品。確定發佈該商品嗎?",
            "提示信息",
            {
              confirmButtonText: "確認",
              cancelButtonText: "取消",
              center: true,
              closeOnClickModal: false
            }
          )
          .then(() => {
            _this.submitFn();
          })
          .catch(() => {});
      }
    },
    // 通过正则过滤小数点后两位
    handlePriceInput(e) {
      e.value = e.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    }
  },
  components: {
    NavBar,
    Editor,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.goods {
  .goodsWrap {
    display: flex;
    margin-bottom: 0.1rem;
    .goodsItem {
      input {
        width: 2rem;
      }
    }
  }
  .goodLine {
    width: 100%;
    height: 0.01rem;
    background: rgba(112, 112, 112, 0.3);
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .addDetail {
    width: 0.8rem;
    height: 0.36rem;
    line-height: 0.36rem;
    text-align: center;
    background: rgba(242, 240, 247, 1);
    color: rgba(147, 142, 164, 1);
    border-radius: 0.04rem;
    cursor: pointer;
  }

  .delBtn {
    display: inline-block;
    margin: 0 0.1rem 0 0.24rem;
    cursor: pointer;
    line-height: 40px;
    color: rgba(108, 61, 234, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/memberGoods.vue